// Build identity, injected by Vite's `define` at build time (see vite.config.ts).
// Guarded with `typeof` so it degrades to safe defaults under Vitest, which uses a
// separate config without the `define` (the token stays undeclared there).

import type { BuildLogEntry } from './buildLog';

declare const __BUILD_SHA__: string;
declare const __BUILD_LOG__: BuildLogEntry[];
declare const __BUILD_BRANCH__: string;
declare const __BUILD_TIME__: string;
declare const __DEV_WORKTREE__: string | null;

/** Short commit SHA of the running build (e.g. `ccf720b`), or `dev` locally. */
export const BUILD_SHA: string =
  typeof __BUILD_SHA__ !== 'undefined' ? __BUILD_SHA__ : 'dev';

/** Branch the build came from (e.g. `maciej-messaging-build`), or empty. */
export const BUILD_BRANCH: string =
  typeof __BUILD_BRANCH__ !== 'undefined' ? __BUILD_BRANCH__ : '';

/** ISO timestamp of when the bundle was built. */
export const BUILD_TIME: string =
  typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '';

/**
 * Recent commits for the „Dev · recent builds” panel, newest first. `[]` in production and stage
 * bundles (the leak rule in `buildLogToInject`) and under Vitest.
 */
export const BUILD_LOG: BuildLogEntry[] =
  typeof __BUILD_LOG__ !== 'undefined' ? __BUILD_LOG__ : [];

/** Dev-only: worktree dir that launched this dev server (null in prod builds). */
export const DEV_WORKTREE: string | null =
  typeof __DEV_WORKTREE__ !== 'undefined' ? __DEV_WORKTREE__ : null;
